import React, { useEffect } from "react"
import {
    Box,
    Typography,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material"
import TextEditor from "../editor/TextEditor"
import MultiSelectChipsBelow from "./MultiSelectChipsBelow"
import ValidationErrorText from "../common/ValidationErrorText"
import { defaultScholarShipOppVal } from "../../containers/course-container/reducer/courseFieldsDefaultValue"

const eligibilityCriteria = [
    "Minimum 75% in Previous Academic Year",
    "Minimum 7.0 CGPA or Equivalent",
    "Applicable to Engineering Students",
    "Applicable to Management Students",
    "Open to All Streams",
    "Family Income Less Than ₹6 LPA",
    "CAT Score ≥ 80 Percentile",
    "GATE Score ≥ 500",
    "Reserved Category – SC",
    "Reserved Category – ST",
    "Reserved Category – OBC",
    "Reserved Category – EWS",
    "Reserved Category – PWD",
    "Resident of Specific State (e.g., Bihar)",
    "Only for Indian Nationals",
    "Must Not Be Receiving Other Major Financial Aid",
    "Based on Entrance Exam Performance",
    "First-Generation Learner Preference",
    "Meritorious Girl Students",
    "Need-Based for Economically Weaker Sections"
]

const inputStyle = {
    height: 38,
    '& .MuiInputBase-input': {
        padding: '8px 12px',
        fontSize: '13px',
    },
}

const ScholarshipOpportunitiesAvailable = ({ label, value = {}, onChange, readOnly = false,fieldErrors,fieldType }) => {
    const { emiEnabled = "yes", eligibility = [], overview = "" } = value

    const handleChange = (field, newValue) => {
        if (readOnly) return
        onChange({ ...value, [field]: newValue })
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Typography fontSize="14px" fontWeight="500" mb={1}>
                {label}
            </Typography>

            <ToggleButtonGroup
                value={emiEnabled}
                exclusive
                onChange={(_, newValue) => {
                    if (readOnly) return
                    if (newValue !== null) handleChange("emiEnabled", newValue)
                }}
                sx={{
                    mb: 2,
                    display: "flex",
                    borderRadius: "30px",
                    overflow: "hidden",
                    padding: '2px',
                    border: "1px solid #ccc",
                    width: "fit-content",
                }}
                disabled={readOnly}
            >
                <ToggleButton value="yes" sx={toggleBtnStyles} disabled={readOnly}>Yes</ToggleButton>
                <ToggleButton value="no" sx={toggleBtnStyles} disabled={readOnly}>No</ToggleButton>
            </ToggleButtonGroup>

            {/* Only show rest if emiEnabled is "yes" */}
            {emiEnabled === "yes" && (
                <>
                    <MultiSelectChipsBelow
                        label="Eligibility Criteria"
                        placeholder="Select Eligibility Criteria"
                        options={eligibilityCriteria}
                        value={eligibility}
                        onChange={newValue => handleChange("eligibility", newValue)}
                        readOnly={readOnly}
                    />
                    <ValidationErrorText error={fieldErrors?.[`${fieldType}.eligibility`]}/>  


                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                        Overview
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 400, mb: 0.5, fontSize: '12px', color: '#6E7485' }}>
                        Please provide details regarding the scholarship criteria.
                    </Typography>
                    <TextEditor
                        value={overview}
                        onChange={text => handleChange("overview", text)}
                        placeholder="Write details regarding the scholarship criteria"
                        readOnly={readOnly}
                    />
                    <ValidationErrorText error={fieldErrors?.[`${fieldType}.overview`]}/>  
                    
                </>
            )}
        </Box>
    )
}

const toggleBtnStyles = {
    flex: 1,
    px: 1,
    py: '0',
    fontSize: '13px',
    minWidth: 'auto',
    borderRadius: '30px !important',
    textTransform: "none",
    fontWeight: "500",
    transition: "0.3s",
    border: 'none',
    "&.Mui-selected": {
        backgroundColor: "#1075FF",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#1565c0",
        },
    },
}

export default ScholarshipOpportunitiesAvailable
